import AnnouncementIcon from "@mui/icons-material/Announcement";
import Badge from "@mui/material/Badge";
import { useSelector } from "react-redux";
import { selectTicketItems } from "../../modules/ticket/ticketList/ticketListSlice";
import {
  getUnreadTicketsCount,
  selectReadTicketsIds,
} from "../../modules/ticket/ticketsRead/ticketsReadActions";

const AnnouncementIconWithBadge = () => {
  const items = useSelector(selectTicketItems);
  const readTicketsIds = useSelector(selectReadTicketsIds);
  const ticketIndicatorCount = getUnreadTicketsCount(items, readTicketsIds);

  return ticketIndicatorCount ? (
    <Badge
      color="secondary"
      overlap="rectangular"
      badgeContent={Number(ticketIndicatorCount)}
    >
      <AnnouncementIcon />
    </Badge>
  ) : (
    <AnnouncementIcon />
  );
};

export default AnnouncementIconWithBadge;
